export class MembersData {
  columns?: MemberColumnInfo[];
}

export class MemberColumnInfo {
  constructor(columnName: string, columnValue: string, type?: ColumnType) {
    this.columnName = columnName;
    this.columnValue = columnValue;
    this.type = type;
  }
  columnName: string;
  columnValue: string;
  isValid?: boolean;
  isRepeated?: boolean;
  cell?: string;
  type?: ColumnType;
  isOriginalRepeated?: boolean;
  columnDescription?: string;
  isDirty?: boolean;
  isVisible?: boolean = true;
  isRequiredInFile?: boolean = true;
}

export enum ColumnType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
  EMAIL = 'email',
  RFC = 'rfc',
  PHONE = 'phone',
}
